// tslint:disable
export enum MedicalCoverageType {
    /**
     * @description In Network
     */
    INN = 1,
    /**
     * @description Out Of Network
     */
    OON = 2,
    /**
     * @description Assignment Of Benefits
     */
    AOB = 3,
}
